export const AGENDA_SLOT_MIN_TIME = '09:00:00';
export const AGENDA_SLOT_MAX_TIME = '21:00:00';
export const SUPPORT_URL = 'https://app--journey-ai-f97cb321.base44.app';
